import { render, staticRenderFns } from "./EWMerchantRegistrationRequestForm.vue?vue&type=template&id=8b4fd216&"
import script from "./EWMerchantRegistrationRequestForm.vue?vue&type=script&lang=js&"
export * from "./EWMerchantRegistrationRequestForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports